import React, { useEffect, useRef } from 'react'
import './Graphicelement.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Graphicelement = () => {
    const sectionRef = useRef(null);
    const cardRefs = useRef([]);

    useEffect(() => {
        const cards = cardRefs.current;

        const initialPositions = [
            { x: 0, y: 100, opacity: 0 },
        ];

        cards.forEach((card, index) => {
            gsap.fromTo(
                card,
                initialPositions[index],
                {
                    x: 0,
                    y: 0,
                    opacity: 1,
                    duration: 1,
                    ease: "power3.out",
                    scrollTrigger: {
                        trigger: card,
                        start: "top 100%",
                        toggleActions: "play none none none",
                        //   markers: true
                    },
                }
            );

            gsap.set(card, { transformOrigin: "center" });

            card.addEventListener("mouseenter", () => {
                gsap.to(card, { scale: 1, duration: 0.3 });
            });

            card.addEventListener("mouseleave", () => {
                gsap.to(card, { scale: 1, duration: 0.3 });
            });
        });
    }, []);
    return (
        <>
            <section className='graphicelementprnt'>
                <div className="custom-container" ref={sectionRef}>
                    <div className="graphicelementheader">
                        <div className="tomilogoheader">
                            <div className="lefttomilogosheader">
                                <h2>3. Graphic Elements</h2>
                            </div>
                            <a className='graphicdownloadlinkbtn secondarybtn' href='\Tomi-Illustrations.zip'>Download Graphic</a>
                        </div>
                    </div>
                    <div className="imgelementgraphic" ref={(el) => (cardRefs.current[0] = el)}>
                        <div className="graphicelementimgsprnt graphicimg1" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg1.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt graphicimg2" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg2.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt graphicimg3" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg3.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt graphicimg4" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg4.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg5.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg6.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg7.png" alt="graphicimg" />

                        </div>
                        <div className="graphicelementimgsprnt" >

                            <img className='img-fluid' src="/assets/Brandguidline/graphicimg8.png" alt="graphicimg" />

                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Graphicelement